import React, { useState, useEffect, useContext } from "react" 
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import { DataLayerEventContext } from "../context/dataLayerEventContext"
import {fetchAllJourneyData, sendSelectedOptions, saveApplication, checkBIExists , updateUserTrackerDetails} from "../../services/apiservice"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { getStateFromCode, getDateInFormat, findCurrentJourneyCode, getValueFromLookup, DataLayerIntegration } from "../services/helperFunctions"
import * as moment from "moment"
import * as lookup from "../../../static/lookup.json";
import {lineCapital, maskInFormat} from '../../shared/functions';
export default function ProvideYourConsent(props) {
  const [apiResult, setApiResult] = useState(null)
    const [datatoPass, setDataToPass] = useState({
    "allJourneyData": null,
    "proceedOption": null,
    "addressOption": null
  })
  const [checked, setChecked] = useState()
  const [proceedOptionError, setProceedOptionError] = useState("")

  const state = lookup["state"];
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [dataLayerEventState, setDataLayerEventState] = useContext(DataLayerEventContext)

  const checkNegativePincode = (pincode) => {  
    //Checking for negative Pincode
if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){
      return false
    }
    const negativePincodes = lookup["negativePincodes"]
    let index = negativePincodes.findIndex(element => element === pincode)
    if(index !== -1){
      let conditionStateValueEducationQualification
      let conditionStateValueAnnualIncome
      if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
        conditionStateValueEducationQualification = conditionState["calculatePremiumPage.CPPersonalDetailsSection.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["calculatePremiumPage.CPPersonalDetailsSection.AnnualIncome"]
      }
      else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
        conditionStateValueEducationQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
      }
            else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
        conditionStateValueEducationQualification = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.AnnualIncome"]
      }
      if(!["1","2"].includes(conditionStateValueEducationQualification)){
        return true
      }else{
        if(conditionStateValueAnnualIncome < 500000){
          return true
        }else {
          return false
        }
      } 
    }else{
      return false
    }
  }

  const getAllJourneyData = async () => {
    let payload = {
      // "journeyId":"60af3842ea22f32efbf53d4a"
      "journeyId": journeyState.journeyId
    }
    let temp = await fetchAllJourneyData(payload)
    console.log(temp, "reponse from provide your consent")
    setApiResult(temp)

    //for selecting default option for proceed option
    if(temp.lifeAssuredDetails.kycVerified){
      let isKycPincodeNegative = checkNegativePincode(temp.lifeAssuredDetails?.kycDetails?.adharAddressPin)
      if(isKycPincodeNegative){
        setDataToPass(prev => {
          return ({
            ...prev,
            "allJourneyData": temp,
            "proceedOption": "manually",
            "addressOption": "both"
          })
        })
        setChecked("manual")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : "ekyc"
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "manually",
                "addressOption": "both"
              })
            })
            setChecked("manual")
          }else{
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "ekyc",
                "addressOption": "both"
              })
            })
            setChecked("ekyc")
          }
        })
      }
    }else if(temp.lifeAssuredDetails.ckycVerified){
      let isCkycPincodeNegative = checkNegativePincode(temp?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)
      if(isCkycPincodeNegative){
        setDataToPass(prev => {
          return ({
            ...prev,
            "allJourneyData": temp,
            "proceedOption": "manually",
            "addressOption": "both"
          })
        })
        setChecked("manual")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : "ckyc"
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "manually",
                "addressOption": "both"
              })
            })
            setChecked("manual")
          }else{
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "ckyc",
                "addressOption": "both"
              })
            })
            setChecked("ckyc")
          }
        })
      }
    }else if(temp?.lifeAssuredDetails?.matchTypeDedupe){
      setDataToPass(prev => {
        return ({
          ...prev,
          "allJourneyData": temp,
          "proceedOption": "dedupe",
          "addressOption": "both"
        })
      })
      setChecked("dedupe")
    }else if(temp?.basicDetails?.ckycSkip === true && temp?.basicDetails?.ekycSkip === true){
      let datatoPass = {
        "allJourneyData": temp,
          "proceedOption": "manually",
          "addressOption": "both"
      }
      setDataToPass(prev => {
        return ({
          ...prev,
          "allJourneyData": temp,
          "proceedOption": "manually",
          "addressOption": "both"
        })
      })
      setChecked("manual")
      if(proceedOptionError){
        if(proceedOptionError === "This pincode is not serviceable"){
          errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : ""}. Basis your input this Plan is not available.`)
          return 
        }else{
          errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
          return 
        }
      }
            let sendPayload = {
        applicationData:  journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          premium: journeyState.premium,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }

      let changeJourneySteps = journeyState.journeySteps
      if (journeyState?.journeyType?.toLowerCase() === "canarapos" && temp.productDetails.premiumFrequency === "SG") {
        changeJourneySteps.pages = changeJourneySteps.pages.filter(
          page => page.pageId !== "makePayment"
        )
      }else if (journeyState?.journeyType?.toLowerCase() === "canarapos") {
        const pageIndex = changeJourneySteps.pages.findIndex(
          page => page.pageId === "makePayment"
        )
        changeJourneySteps.pages[pageIndex].sections = changeJourneySteps.pages[pageIndex].sections.filter(
          section => section.sectionId === "eNach-physicalMandate"
        )
      } else {
        // Remove SCR section for normal journey
        const pageIndex = changeJourneySteps.pages.findIndex(
          page => page.pageId === "PageFlexiEdgeUploadDocuments"
        )
        changeJourneySteps.pages[pageIndex].sections = changeJourneySteps.pages[pageIndex].sections.filter(
          section => section.sectionId !== "salesConfidentialReport"
        )
      }

      saveApplication(sendPayload).then(res => { 
                  setJourneyState((prev) => {
            return ({
              ...prev,
              lastPage: props.currentPageIndex,
              lastSection: props.currentSectionIndex + 1,
              lastPageCode: props.pageId,
              lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
              journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId),
              journeySteps: changeJourneySteps
            })
          })
console.log(datatoPass, "data to pass") 
        sendSelectedOptions(datatoPass).then(res => {
          props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
          console.log(res)
        })
      }).catch(err => {
        console.log(err, "err in saveApplication")
      })
    }
  }

  useEffect(() => {
    getAllJourneyData()
  },[])


  const handleSubmit = (ev)=>{
    let sectionIndex = props.currentSectionIndex
    let pageIndex = props.currentPageIndex
    let sectionIndexToEmpty = sectionIndex + 1
    let pageSectionIndexToEmpty =`${pageIndex}${sectionIndexToEmpty}`
    let eventCalledToFillObject = {}
    let eventCalledToFill = Object.keys(
      dataLayerEventState?.eventCalled
    ).filter(element => {
      return element !== pageSectionIndexToEmpty
    })
    console.log(eventCalledToFill);
    for(let i=0; i<eventCalledToFill.length;i++){
      eventCalledToFillObject[eventCalledToFill[i]] = true
    }
    console.log(eventCalledToFillObject);
    console.log(dataLayerEventState);
    if(dataLayerEventState.eventCalled[pageSectionIndexToEmpty]){
      setDataLayerEventState(prev=>{
        return{
          eventCalled:{
            ...eventCalledToFillObject
          }
        }
      })
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    try {
      const payload = {
        journeyId: journeyState?.journeyId, 
        buttonClicked: `provide-your-consent with ${checked} ` , 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handleSubmit", error);
    }
    if(proceedOptionError){
      if(proceedOptionError === "This pincode is not serviceable"){
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : ""}. Basis your input this Plan is not available.`)
        return 
      }else{
        errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
        return 
      }
    }
        let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        premium: journeyState.premium,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
              },
    }

    let temp = journeyState.journeySteps
    if (journeyState?.journeyType?.toLowerCase() === "canarapos" && apiResult.productDetails.premiumFrequency === "SG") {
      temp.pages = temp.pages.filter(
        page => page.pageId !== "makePayment"
      )
    }else if (journeyState?.journeyType?.toLowerCase() === "canarapos") {
      const pageIndex = temp.pages.findIndex(
        page => page.pageId === "makePayment"
      )
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
        section => section.sectionId === "eNach-physicalMandate"
      )
    } else {
      // Remove SCR section for normal journey
      const pageIndex = temp.pages.findIndex(
        page => page.pageId === "PageFlexiEdgeUploadDocuments"
      )
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
        section => section.sectionId !== "salesConfidentialReport"
      )
    }

    saveApplication(sendPayload).then(res => { 
              setJourneyState((prev) => {
          return ({
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex + 1,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId),
                        journeySteps: temp
          })
        })
console.log(datatoPass, "data to pass") 
      sendSelectedOptions(datatoPass).then(res => {
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
        console.log(res)
      })
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const handleEnter =(event1,event2) =>{
    console.log({event2});
    if(event1.key == 'Enter'){
      handleSelection(event2)
    }
  }

  const handleSelection = ({target}) => {
    try {
      const payload = {
        journeyId: journeyState?.journeyId, 
        buttonClicked: `provide-your-consent with ${target.value} selection ` , 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handleSelection", error);
    }

    if(target.value === "ekyc" || target.value === "ckyc"){
      let isPincodeOfSelectedOptionNegative
      if(target.value === "ekyc"){
        isPincodeOfSelectedOptionNegative = checkNegativePincode(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressPin)
      }else {
        isPincodeOfSelectedOptionNegative = checkNegativePincode(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)
      }
      if(isPincodeOfSelectedOptionNegative){
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : ""}. Basis your input this Plan is not available.`)
        setProceedOptionError("This pincode is not serviceable")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : target.value
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
            setProceedOptionError("Cannot select this option")
            return 
          }else{
            setProceedOptionError("")
          }
        })
      }
    }else{
      setProceedOptionError("")
    }
    // console.log(target)
    switch (target.value) {
      case "ekyc":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "ekyc"
          })
        })
        setChecked("ekyc")
        break;
      case "ckyc":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "ckyc"
          })
        })
        setChecked("ckyc")
        break;
      case "dedupe":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "dedupe"
          })
        })
        setChecked("dedupe")
        break;
      case "manually":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "manually"
          })
        })
        setChecked("manual")
        break;
      default:
        break;
    }
    // console.log(datatoPass)
  }

  const handleValueChange = ({ target }) => {
    // console.log(target.value)
    switch (target.value) {
      case "currentAddress":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "currentAddress"
          })
        })
        break;
      case "permanentAddress":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "permanentAddress"
          })
        })
        break;
      case "both":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "both"
          })
        })
        break;
    
      default:
        break;
    }
    // console.log(datatoPass)
  }

   // code of tab enter
   const handleEnterAddress = (event, event2) =>{
    if(event?.key == 'Enter'){
      handleValueChange(event2)
      // aadharOtp(event);
    }
  }

  return (
    <>
      {/* <Header /> */}
      <style>
        {`
            .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                margin-left:-2px;
            }
            ::-ms-clear {
                display: none;
            }
            @media (min-width: 768px) and (max-width: 991px) {
                .left-side-head {
                    width: 60%;
                }
            }
            .input-group.date .input-group-addon{
                background:none;
            }
        
            @media (max-width: 767px){
                .form-group {
                    margin-bottom: 34px;
                }    
            }    
            .d-none{
                display: none;
            }   
            .br-0{
                border-radius: 0px !important;
             }
                     `}
      </style>

      {/* body Section */}
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head">
                    <h1 className="iselect-heading">
                      Provide your consent to proceed
                    </h1>
                  </div>
                  <div className="app-quatation q3-mt1 hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>
                {apiResult && 
                <div className="iselect-padding details-esign">
                  { apiResult.lifeAssuredDetails && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed to enter details manually{" "}
                          </span>
                          <input type="radio" name="spouse" value="manually" checked={checked === "manual" ? true : false} onChange={handleSelection} />
                      <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'manually'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                  </>
                  }
                  {(apiResult.lifeAssuredDetails.kycVerified) && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per E-KYC Records{" "}

                          </span>
                          <input
                            type="radio"
                            name="spouse"
                            value="ekyc"
                            checked={checked === "ekyc" ? true : false}
                            onChange={handleSelection}
                          />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'ekyc'}})}></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div className="row">
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycFirstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycMiddleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycLastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right"> {lineCapital(getValueFromLookup("gender",apiResult?.lifeAssuredDetails?.kycDetails?.kycGender))} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">{maskInFormat(apiResult?.lifeAssuredDetails?.kycDetails?.kycDateOfBirth * 1000) || "NA"} </td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine1 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine1?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine2 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine2?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine3 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine3?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> {lineCapital(state[0][apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressState])} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressCity)}</td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressPin)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }
                  {(apiResult.lifeAssuredDetails.ckycVerified) &&
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per CKYC Records{" "}
                          </span>
                          <input type="radio" name="spouse" value="ckyc" checked={checked === "ckyc" ? true : false} onChange={handleSelection} />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'ckyc'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div className="row">
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCFirstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCMiddleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCLastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right">{lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCGender)}</td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">{maskInFormat(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCDOB * 1000) || "NA"}</td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd1 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd1?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd2 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd2?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd3 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd3?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> {lineCapital(state[0][apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddState])} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddCity)} </td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }
                  {(apiResult?.lifeAssuredDetails?.matchTypeDedupe) && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per Canara HSBC Life
                            Insurance Records{" "}
                          </span>
                          <input type="radio" name="spouse" value="dedupe" checked={checked === "dedupe" ? true : false} onChange={handleSelection}  />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'dedupe'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div className="row">
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.firstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.middleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.lastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right"> 
                                {lineCapital(getValueFromLookup("gender",apiResult?.lifeAssuredDetails?.dedupeLa?.gender))}  </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">  {maskInFormat(apiResult?.lifeAssuredDetails?.dedupeLa?.dob * 1000) || "NA"}   </td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine1) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine1?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine2) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine2?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine3) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine3?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> 
                                {lineCapital(state[0][apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTstate])}
                                {/* {apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTstate} */}
                                 </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTcity)} </td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTpincode)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }

                  <div className="iselect-mg-bottom">
                    <div className="col-md-12 col-xs-12 smace">
                      <div className="form-group">
                        <div className="radio-section-design">
                          <p>
                            Please confirm whether the selected address is your
                            current or permanent address?{" "}
                          </p>
                        </div>
                        <div className="radio-line radio-design sa11">
                          <label className="customradio">
                            <span className="radiotextsty">
                              Current Address
                            </span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="currentAddress"
                              checked = {datatoPass.addressOption == 'currentAddress'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value: "currentAddress"}})}></span>{" "}
                          </label>
                        </div>
                        <div className="radio-line radio-design">
                          <label className="customradio">
                            <span className="radiotextsty">
                              Permanent Address
                            </span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="permanentAddress"
                              checked = {datatoPass.addressOption == 'permanentAddress'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value:"permanentAddress"}})}></span>{" "}
                          </label>
                        </div>
                        <div className="radio-line radio-design">     
                          <label className="customradio">
                            <span className="radiotextsty">Both</span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="both"
                              defaultChecked
                              checked = {datatoPass.addressOption == 'both'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value:"both"}})}></span>{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <div
                          className="previous-btn cen"
                          style={{ display: "none" }}
                        >
                          {" "}
                          <a >Skip </a>{" "}
                        </div>
                        <a>
                          {" "}
                          <input
                            className="provider previous-btn cen"
                            tabIndex="0"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                              backgroundColor: "#db0011 !important",
                            }}
                            type="submit"
                            value="Proceed"
                            onClick={handleSubmit}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div> 
            </div>
          </div>
        </div>
      </div>

      {/* body Section */}
      <div className="clearfix"></div>
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="previous-btn cen" style={{ display: "none" }}>
                {" "}
                <a>Skip </a>{" "}
              </div>
              <a>
                <input
                  className="previous-btn cen"
                  style={{
                    width: "auto",
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                    backgroundColor: "#db0011 !important",
                  }}
                  type="submit"
                  value="Proceed"
                  onClick={handleSubmit}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  )
}
